import React from "react";
import { CUSTOM_COLUMN_FORM_KEYS } from "../../constants/CustomColumnFormField.constants";
import { Field, useFormState } from "react-final-form";
import { generateInputDefaultValuesProps } from "./utils/DefaultValueField.utils";
import { FormFieldLabel } from "features/Common/modules/Form/modules/FormFieldLabel/FormFieldLabel";
import useOrgMemberList from "utils/hooks/useOrgMemberList";

export const DefaultValueField = ({
  formKeyObj,
  validate = () => {},
  required = false,
}) => {
  const { orgMembers } = useOrgMemberList();

  const {
    values: {
      [CUSTOM_COLUMN_FORM_KEYS.field_type.key]: fieldType,
      [CUSTOM_COLUMN_FORM_KEYS.options.key]: optionsEnteredByCreator,
    },
  } = useFormState();

  return (
    <div>
      <div className="mt-0 mb-2">
        <FormFieldLabel
          formKeys={CUSTOM_COLUMN_FORM_KEYS}
          formKey={formKeyObj.key}
          classes={{ labelClassName: "mr-1", spanClassName: "ml-0" }}
          required={required}
        />
      </div>
      {fieldType ? (
        <Field
          name={formKeyObj.key}
          fullWidth
          size="small"
          tall
          {...generateInputDefaultValuesProps({
            type: fieldType,
            options: optionsEnteredByCreator,
            orgMembers,
          })}
          validate={validate}
        />
      ) : (
        <div className="tw-text-[rgba(39,37,34,0.3)] tw-text-[14px] tw-italic tw-font-[400] tw-leading-normal">
          {formKeyObj.placeholder}
        </div>
      )}
    </div>
  );
};
